// --------------
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// IE11 Polyfills
import { default as functionName } from 'function.name-polyfill'; // eslint-disable-line no-unused-vars
import { default as stringStartsWith } from 'string.prototype.startswith'; // eslint-disable-line no-unused-vars

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@awesomecomponents/mux/core/typography/assets/fonts/fonts.css';
import { initExternalConfig } from './utils/configuration';

import { Logger } from 'alf-ui-js';

const logger = new Logger(
  {
    syslog: {
      hostName: window.location.hostname,
      appName: window.__ENV__.ULS_APP_NAME,
    },
    correlation: {
      channel: 'web',
    },
    ULS: {
      applicationCINumber: window.__ENV__.ULS_APP_CI,
      environmentCINumber: window.__ENV__.ULS_ENVIRONMENT_CI,
      environment: window.__ENV__.ULS_ENVIRONMENT,
    },
  },
  {
    remoteURL: `${window.__ENV__.BFF_CONFIG.bff}/log/v3/send`,
  },
);

const findIndex = require('array.prototype.findindex');
const find = require('array.prototype.find');
findIndex.shim();
find.shim();
initExternalConfig();

ReactDOM.render(<App name="Formhero App" logger={logger} />, document.getElementById('root'));
